import {GetConfigFunc} from '../../../types';
import {
  EventTypes,
  HandleEventCallback,
  IEntityResponseService,
} from '../../types';
import {getChannelAndScopeKey} from '../functions/getChannelAndScopeKey';
import {getPusherSingleton} from './getPusherSingleton';

export const createPusherService = <
  TData extends Record<TIdKey, any>,
  TEntityName extends string = any,
  TIdKey extends keyof TData = keyof TData
>(
  getConfig: GetConfigFunc,
): IEntityResponseService<TData, TEntityName, TIdKey> => {
  const service: IEntityResponseService<TData, TEntityName, TIdKey> = {
    subscribe: (
      accessToken: string,
      scope: string | number | undefined,
      channelName: TEntityName,
      events: EventTypes[],
      callback: HandleEventCallback<TData, TIdKey>,
    ) => {
      const pusher = getPusherSingleton(accessToken, getConfig);
      console.log('Connecting to pusher channel', channelName);
      const channel = pusher.subscribe(
        getChannelAndScopeKey(channelName, scope),
      );
      console.log('Got channel:', channel, 'binding to events');
      events.forEach(evt =>
        channel.bind(evt, (data: TData) => callback(evt, data)),
      );
    },
    unsubcribe: (
      accessToken: string,
      scope: string | number | undefined,
      channelName: TEntityName,
    ) => {
      console.log('Disconnecting from pusher channel', channelName);
      const pusher = getPusherSingleton(accessToken, getConfig);
      pusher.unsubscribe(getChannelAndScopeKey(channelName, scope));
    },
  };

  return service;
};
